import * as React         from 'react';
import { useTranslation } from 'react-i18next';

import CalendarNextArrowIcon from '../icons/CalendarNextArrowIcon';
import CalendarPrevArrowIcon from '../icons/CalendarPrevArrowIcon';

import DaysGrid from './components/DaysGrid';

const Calendar = function(props) {
  const { t } = useTranslation();

  const {
          getDate,
          resetSelect,
        } = props;

  const { current: dayNames }   = React.useRef([
    t('calendar_day_monday'),
    t('calendar_day_tuesday'),
    t('calendar_day_wednesday'),
    t('calendar_day_thursday'),
    t('calendar_day_friday'),
    t('calendar_day_saturday'),
    t('calendar_day_sunday'),
  ]);
  const { current: monthNames } = React.useRef([
    t('calendar_month_january'),
    t('calendar_month_february'),
    t('calendar_month_march'),
    t('calendar_month_april'),
    t('calendar_month_may'),
    t('calendar_month_june'),
    t('calendar_month_july'),
    t('calendar_month_august'),
    t('calendar_month_september'),
    t('calendar_month_october'),
    t('calendar_month_november'),
    t('calendar_month_december'),
  ]);

  const [currentDate, setCurrentDate]             = React.useState(new Date());
  const [isCalendarVisible, setIsCalendarVisible] = React.useState(false);
  const [selectedDate, setSelectedDate]           = React.useState(new Date());

  const currentYear   = React.useMemo(() => {
    return currentDate.getFullYear();
  }, [currentDate]);
  const currentMonth  = React.useMemo(() => {
    return currentDate.getMonth();
  }, [currentDate]);
  const isOpened      = React.useMemo(() => {
    return props.isOpened();
  }, [props.isOpened]);
  const selectedYear  = React.useMemo(() => {
    return selectedDate.getFullYear();
  }, [selectedDate]);
  const selectedMonth = React.useMemo(() => {
    return selectedDate.getMonth();
  }, [selectedDate]);

  const getDaysInMonth       = React.useCallback((date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }, []);
  const getFirstDayOfMonth   = React.useCallback((date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  }, []);
  const handlePrevMonth      = React.useCallback((event) => {
    event.stopPropagation();
    event.preventDefault();

    setCurrentDate(new Date(currentYear, currentMonth - 1, 1));
  }, [currentMonth, currentYear]);
  const handleNextMonth      = React.useCallback((event) => {
    event.stopPropagation();
    event.preventDefault();

    setCurrentDate(new Date(currentYear, currentMonth + 1, 1));
  }, [currentMonth, currentYear]);
  const handleDateSelect     = React.useCallback((day, month) => {
    if (month < currentMonth) {
      const newDate = new Date(currentYear, currentMonth - 1, day);

      setCurrentDate(newDate);
      setSelectedDate(newDate);
    } else if (month > currentMonth) {
      const newDate = new Date(currentYear, currentMonth + 1, day);

      setCurrentDate(newDate);
      setSelectedDate(newDate);
    } else {
      setSelectedDate(new Date(currentYear, currentMonth, day));
    }
  }, [currentYear, currentMonth]);
  const handleContainerClick = React.useCallback((event) => {
    if (event.target.closest('.calendar')) {
      return;
    }

    setIsCalendarVisible(false);

    resetSelect();
  }, [resetSelect]);
  const handleCloseCalendar  = React.useCallback(() => {
    setIsCalendarVisible(false);
  }, []);
  const handleSelectDate     = React.useCallback(() => {
    const day           = selectedDate.getDate()
      .toString()
      .padStart(2, '0');
    const month         = (selectedMonth + 1)
      .toString()
      .padStart(2, '0');
    const formattedDate = `${day}.${month}.${selectedYear}`;

    getDate(formattedDate);

    setIsCalendarVisible(false);
  }, [selectedDate, selectedMonth, selectedYear, getDate]);

  React.useEffect(() => {
    if (isOpened) {
      setIsCalendarVisible(true);
    }
  }, [isOpened]);

  if (!isCalendarVisible) {
    return null;
  }

  return (
    <div
      className={'calendar_container'}
      onClick={handleContainerClick}
    >
      <div className={'calendar'}>
        <div className={'header'}>
          <button
            className={'calendar_btn calendar_btn_left'}
            onClick={handlePrevMonth}
          ><CalendarPrevArrowIcon /></button>
          <div className={'month_year'}>{monthNames[currentMonth]} {currentYear}</div>
          <button
            className={'calendar_btn calendar_btn_right'}
            onClick={handleNextMonth}
          ><CalendarNextArrowIcon /></button>
        </div>
        <div className={'days_of_week'}>
          {dayNames.map((day, index) => {
            return (
              <div
                className={'day_name'}
                key={index}
              >{day}</div>
            );
          })}
        </div>
        <DaysGrid
          currentDate={currentDate}
          getDaysInMonth={getDaysInMonth}
          getFirstDayOfMonth={getFirstDayOfMonth}
          handleDateSelect={handleDateSelect}
          selectedDate={selectedDate}
        />
        <div className={'footer'}>
          <button
            className={'btn primary'}
            onClick={() => {
              handleCloseCalendar();
              resetSelect();
            }}
          >Отмена
          </button>
          <button
            className={'btn fill'}
            onClick={handleSelectDate}
          >Выбрать
          </button>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
